import { dcrRegistrationChanged } from "./dcr";
import { connectorsByIdentifier } from "./index";
import { normalizeConnectorUrlPattern } from "./normalizeUrlPattern";

export type GrantBinding = {
  identifier: string;
  urlPattern: string;
  configuration: Record<string, string>;
  oauthClientId: string | null;
};

export function grantBinding(app: GrantBinding) {
  const oauth = connectorsByIdentifier[app.identifier]?.oauth;
  return JSON.stringify([
    app.identifier,
    app.urlPattern,
    app.oauthClientId,
    oauth?.authorizationEndpoint?.(app.configuration),
    oauth?.tokenEndpoint(app.configuration),
    app.configuration.caCertificate,
  ]);
}

type ConnectorUpdate = Partial<
  Pick<GrantBinding, "urlPattern" | "configuration" | "oauthClientId"> & {
    oauthRequestedScopes: string[];
  }
>;

export function updateRemovesVisitorGrants(
  app: GrantBinding & {
    authorizationMode: string | null;
    oauthRequestedScopes: string[] | null;
  },
  update: ConnectorUpdate
) {
  if (app.authorizationMode !== "visitor") return false;
  const configuration = update.configuration ?? app.configuration;
  const next = {
    ...app,
    ...update,
    urlPattern:
      update.urlPattern === undefined && update.configuration === undefined
        ? app.urlPattern
        : normalizeConnectorUrlPattern(
            update.urlPattern ?? app.urlPattern,
            app.identifier,
            configuration,
            app.configuration
          ),
  };
  const resetsClient =
    update.oauthClientId === undefined && dcrRegistrationChanged(app, next);
  return (
    grantBinding(app) !==
    grantBinding(resetsClient ? { ...next, oauthClientId: "" } : next)
  );
}
